export const getNumericEnumValuesArray = (enumItem: any): Array<string> => {
	return Object.keys(enumItem).filter((value) => isNaN(Number(value)));
};

export const getNumericEnumLength = (enumItem: any): number => {
	return getNumericEnumValuesArray(enumItem).length;
};
